import { call, take, put }        from 'redux-saga/effects';
import axios                      from 'axios';
import { 
   GET_STUDENTS_INFO_SAGA, 
   SET_USER_INFO 
}                                 from '../actions';

const userInfoEndpoint       = `https://www.yisumatica.org.il/chk_session`;
const userAttributesEndpoint = 'api/getUserId.php';

function* getUserInfo(): Generator<any,any,any> {
  while(true) {
    try {

        yield take('GET_USER_INFO_SAGA');

        if (process.env.NODE_ENV === 'development') {
            const payload = {
                userLogedIn: 'true',
                userName:    'test',
                userEmail:   'test@test.test',
             //   userRole:    'student',
                userRole:    'teacher',
                teacherId:   999
            }

            yield put(SET_USER_INFO( payload ))
            yield put(GET_STUDENTS_INFO_SAGA( payload ))
            return
        }

        console.log('getting user info')
        
        const userInfo = yield call( axios.get, userInfoEndpoint);
        
        const infoStr = userInfo.data;


        const n1 = infoStr.search('name=')
        const n2 = infoStr.search('&mail=')
        const n3 = infoStr.search('&user=')
        const n4 = infoStr.search('&semel_mosad=')

        let name = '', email = '', role = '', id = -1, logedIn = '';

        if (n1 !== -1 && n2 !== -1 && n3 !== -1 && n4 !== -1) {
          name  = infoStr.slice(n1 + 5, n2);
          email = infoStr.slice(n2 + 6, n3);
          role  = infoStr.slice(n3 + 6, n4) === 'student' ? 'student' : 'teacher';
         /*  if (name === 'Raphael Shalem') {
            role = 'student'
         } */
        }
        
        if (email.length) {
           
           console.log('getting user attributes')
           
           const userAttributes = yield call( 
             axios.post, 
             userAttributesEndpoint, 
             { 
                userName: name,
                userEmail: email,
                userRole: role
             }
           )

           if (userAttributes && userAttributes.data && userAttributes.data[0]) {
              logedIn = 'true'
              console.log('userAttributes.data[0]   :   ',userAttributes.data[0])
              id = role === 'teacher' ? userAttributes.data[0].userId : userAttributes.data[0].teacherId;
           }
           else {
            logedIn = 'false'
           }
        }
        else {
          logedIn = 'false'
        }

        const payload = {
            userLogedIn: logedIn,
            userName:    name,
            userEmail:   email,
            userRole:    role,
            teacherId:   id
        }

        yield put(SET_USER_INFO( payload ))

        if (role === 'teacher') {
          yield put(GET_STUDENTS_INFO_SAGA( payload ))
        }

    }
    catch(err) {
      const payload = {
        userLogedIn: 'false',
        userName:    '',
        userEmail:   '',
        userRole:    'student',
        teacherId:    -1
      }

      yield put(SET_USER_INFO( payload ))
      console.log('err  :  '+err);

    }
    finally {}
  }
}


export default getUserInfo;
